import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthLandingComponent } from './components/routes/auth/auth-landing/auth-landing.component';
import { ConfirmResetComponent } from './components/routes/auth/confirm-reset/confirm-reset.component';
import { RequestResetComponent } from './components/routes/auth/request-reset/request-reset.component';
import { SignupComponent } from './components/routes/auth/signup/signup.component';
import {AgencyDisabledComponent} from './components/routes/auth/agency-disabled/agency-disabled.component';
import {ServerDownComponent} from "./components/routes/auth/server-down/server-down.component";

const routes: Routes = [
  // Auth
  { path: 'auth/landing', component: AuthLandingComponent },
  { path: 'auth/reset-request', component: RequestResetComponent },
  { path: 'auth/server-down', component: ServerDownComponent },
  { path: 'auth/agency-disabled', component: AgencyDisabledComponent },
  { path: 'Signup/:confirmationKey', component: SignupComponent },
  { path: 'PasswordReset/:confirmationKey', component: ConfirmResetComponent },
  // Patient
  {
    path: 'patient',
    loadChildren: () =>
      import('./components/routes/patient/patient.module').then(
        mod => mod.PatientRoutesModule
      )
  },
  // Admin
  {
    path: 'admin',
    loadChildren: () =>
      import('./components/routes/admin/admin.module').then(
        mod => mod.AdminRoutesModule
      )
  },
  {
    path: 'webhook',
    loadChildren: () =>
      import('./components/routes/webhook/webhook.module').then(
        mod => mod.WebhookRoutesModule
      )
  }
  // Webhooks
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
